var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "520px",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "mt-4 d-flex" },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      attrs: {
                        primary: "",
                        loading: _vm.loading,
                        disabled: _vm.loading,
                        "data-test": "save-resposta-btn"
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v(" " + _vm._s(_vm.confirmLabel) + " ")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.modalTitle))
          ])
        ]),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c("v-form", { ref: "form" }, [
              _c(
                "div",
                { staticClass: "pa-4" },
                [
                  _c("input-by-type", {
                    staticClass: "mb-4",
                    staticStyle: { "min-width": "175px" },
                    attrs: {
                      type: "text",
                      outlined: "",
                      dense: "",
                      labelExternal: "Título*",
                      placeholder: "Ex.: Saudação",
                      maxlength: 100,
                      "data-test": "form-titulo",
                      rules: [_vm.rules.required]
                    },
                    model: {
                      value: _vm.form.titulo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "titulo", $$v)
                      },
                      expression: "form.titulo"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "modal-textarea-container" },
                    [
                      _c("input-by-type", {
                        attrs: {
                          type: "textarea-new-ux",
                          labelExternal: "Conteúdo*",
                          placeholder: "Digite o texto que será enviado...",
                          rows: "4",
                          rules: [_vm.rules.required],
                          "data-test": "form-conteudo"
                        },
                        model: {
                          value: _vm.form.conteudo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "conteudo", $$v)
                          },
                          expression: "form.conteudo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }